/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat BotTracker viewer. */
(function () {
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["bottracker"] = "1.0.4"; } catch (e) {}
  
  
  function bsCls(v){return v>=70?"s-hi":(v>=40?"s-mid":"s-lo");}
  /* What the number means. "BotScore 82 · scraper · conf 0.90" is a readout, not an explanation —
     nobody knows whether 82 is good or bad, or what the confidence is confidence IN. */
  function bsTip(b){
    var t = ["BotScore " + b.botscore + "/100 \u2014 how strongly this traffic behaves like automation.",
             TR('bottra.f3.higher_more_bot_like_scored_from_r'),
             "signals \u2014 not from the user-agent alone, which anyone can set."];
    if (b.botscore_cat) t.splice(1, 0, "Behaviour: " + b.botscore_cat);
    if (b.botscore_conf != null) t.splice(b.botscore_cat ? 2 : 1, 0,
      "Confidence " + Math.round((+b.botscore_conf || 0) * 100) + "% \u2014 how much evidence the score rests on.");
    return t.join("\n");
  }
  function bsBadge(b){ if(b.botscore==null) return "";
    return ' <span class="bscore '+bsCls(b.botscore)+'" title="'+esc(bsTip(b))+'"><i class="bi bi-robot"></i>'+b.botscore+"</span>"; }

  /* Who is this crawler, and can I trust the badge?
     owner/url come from BotSignatures and are null for the long tail — then it stays a bare name
     rather than a fabricated operator. `verified` is the part that matters: any script can send
     Googlebot's user-agent, so "says Googlebot" and "is Googlebot" are different claims. */
  function botName(b){
    var t = [];
    if (b.owner) t.push("Operated by " + b.owner);
    if (b.category_help) t.push(b.category_help);
    t.push(b.verified
      ? TR('bottra.f3.verified_u2014_the_request_came_fr')
      : "Not verified \u2014 the user-agent claims this bot, but the IP is not in the operator's published ranges (or none are published).");
    if (b.last_seen) t.push("Last seen " + b.last_seen);
    if (b.url) t.push(TR('bottra.p.click_the_name_for_the_operator_s_ow'));
    var label = esc(b.name);
    if (b.url) label = '<a class="bot-doc" href="'+esc(b.url)+'" target="_blank" rel="noopener noreferrer nofollow">'+label+'</a>';
    return '<span class="bot-nm" title="'+esc(t.join("\n"))+'">'+label+(b.owner?'<span class="bot-own">'+esc(b.owner)+"</span>":"")+"</span>";
  }
function ic(n){return (window.GSIcons&&GSIcons.svg)?(GSIcons.svg(n,16)+" "):"";}
if (window.__botWired) return; window.__botWired = 1;
  var root;
  function q(s) { return root ? root.querySelector('[data-b="' + s + '"]') : null; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function ready(fn) { var done = false; function go() { if (done) return; done = true; fn(); } document.addEventListener("gs:ready", go, { once: true }); var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30); if (window.GS && GS.api && GS.site) go(); }
  function ago(s) { if (!s) return "\u2014"; var d = new Date(s.replace(" ", "T") + "Z"); var sec = (Date.now() - d.getTime()) / 1000; if (isNaN(sec)) return esc(s); if (sec < 90) return "just now"; if (sec < 3600) return Math.round(sec / 60) + "m ago"; if (sec < 86400) return Math.round(sec / 3600) + "h ago"; return Math.round(sec / 86400) + "d ago"; }

  function renderSplit(t) {
    var host = q("split"), bot = t.bot_sessions || 0, hum = t.human_sessions || 0, tot = bot + hum || 1;
    var bp = Math.round(bot / tot * 100), hp = 100 - bp;
    host.innerHTML = '<div class="sbar"><i class="h" style="width:' + hp + '%"></i><i class="b" style="width:' + bp + '%"></i></div>' +
      '<div class="slab"><span><b>' + hum.toLocaleString() + '</b> human sessions</span><span><b>' + bot.toLocaleString() + '</b> bot sessions \u00b7 ' + (t.bot_pct || 0) + '%</span></div>';
  }
  function renderDaily(days) {
    var host = q("daily");
    if (!days || !days.length) { host.innerHTML = '<div class="empty">'+TR('bottra.f2.no_traffic_in_this_range')+'</div>'; return; }
    var max = days.reduce(function (m, d) { return Math.max(m, (d.bots || 0) + (d.humans || 0)); }, 1);
    host.innerHTML = days.map(function (d) {
      var b = (d.bots || 0), h = (d.humans || 0), tot = b + h;
      var scale = tot / max * 100;
      var bh = tot ? (b / tot * scale) : 0, hh = tot ? (h / tot * scale) : 0;
      return '<div class="dcol" title="' + d.date + ": " + h + " human, " + b + ' bot"><i class="b" style="height:' + bh + '%"></i><i class="h" style="height:' + hh + '%"></i></div>';
    }).join("");
  }
  function renderCats(cats) {
    var host = q("cats");
    if (!cats.length) { host.innerHTML = '<div class="empty">'+TR('bottra.f2.no_bots_in_this_range')+'</div>'; return; }
    var max = cats[0].share || 1;
    host.innerHTML = cats.map(function (c) {
      return '<div class="crow"><div class="top"><span class="dot" style="background:' + esc(c.color) + '"></span>' + esc(c.label) +
        '<span class="pct num">' + c.share + '%</span></div>' +
        '<div class="track"><i style="width:' + Math.max(3, Math.round(c.share / max * 100)) + '%;background:' + esc(c.color) + '"></i></div>' +
        '<div class="n">' + c.sessions.toLocaleString() + ' sessions \u00b7 ' + c.bots + ' bot' + (c.bots === 1 ? "" : "s") + '</div></div>';
    }).join("");
  }
  function renderTable(bots) {
    var tb = q("tbody");
    function botRow(b) {
      var thr = b.bad ? ' <span class="thr" title="' + esc(b.doing || "") + '"><i class="bi bi-exclamation-triangle-fill"></i>' + esc(b.threat_label || "Threat") + "</span>" : "";
      var vb = "";
      if (!b.bad) { if (b.verified) vb = ' <span class="vok"><i class="bi bi-shield-check"></i>'+TR('bottra.g.verified')+'</span>'; else if (b.category === "ai" || b.category === "search") vb = ' <span class="vno">'+TR('bottra.g.unverified')+'</span>'; }
      var blk = b.block ? ' <a href="#" class="bb-go" data-bb-open="' + esc(b.block) + '"><i class="bi bi-shield-x"></i>' + esc(TR("bot.block_row")) + "</a>" : "";
      return "<tr" + (b.bad ? ' class="bad"' : "") + '><td class="bn">' + ic(b.name) + botName(b) + thr + vb + bsBadge(b) + blk + "</td>" +
        '<td><span class="badge" style="background:' + esc(b.color) + '1a;color:' + esc(b.color) + '"><span class="d" style="background:' + esc(b.color) + '"></span>' + esc(b.category_label) + "</span></td>" +
        '<td class="r num">' + b.sessions.toLocaleString() + "</td>" +
        '<td class="r num">' + b.pageviews.toLocaleString() + "</td>" +
        '<td class="r num">' + b.countries + "</td>" +
        '<td class="r">' + ago(b.last_seen) + "</td></tr>";
    }
    bots = bots || [];
    if (window.GSMore) GSMore.mount({ container: tb, table: true, colspan: 6, items: bots, pageSize: 20, emptyText: TR('bottra.f2.no_bots_detected_in_this_range'), render: botRow });
    else tb.innerHTML = bots.length ? bots.map(botRow).join("") : '<tr><td colspan="6" class="empty">'+TR('bottra.f2.no_bots_detected_in_this_range')+'</td></tr>';
  }

  function render(d) {
    var t = d.totals || {};
    q("k-sessions").textContent = (t.bot_sessions || 0).toLocaleString();
    q("k-pct").textContent = (t.bot_pct || 0) + "%";
    q("k-unique").textContent = (t.unique_bots || 0).toLocaleString();
    q("k-top").textContent = d.top_bot || "\u2014";
    renderSplit(t); renderDaily(d.days || []); renderCats(d.categories || []); renderTable(d.bots || []);
  }
  function load() {
    GS.api("/plugin/bottracker/overview?" + siteParam() + "&from=" + RANGE.from + "&to=" + RANGE.to).then(function (r) {
      if (r.ok && r.data) render(r.data);
    });
  }

  function _ymd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
  function _today() { var t = new Date(); return new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days) { var to = _today(), from = new Date(to.getTime() - (days - 1) * 86400000); var lbl = { 7: T("an.last7"), 30: T("an.last30"), 90: T("an.last90"), 365: T("an.last12mo") }[days] || T("an.lastndays",{n:days}); return { from: _ymd(from), to: _ymd(to), label: lbl, preset: String(days) }; }
  var RANGE = (function () { try { var s = JSON.parse(localStorage.getItem("gs_bot_range") || "null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if (s && s.from && s.to) return s; } catch (e) {} return preset(30); })();
  function saveRange() { try { localStorage.setItem("gs_bot_range", JSON.stringify(RANGE)); } catch (e) {} }

  function initRange() {
    var btn = q("rangeBtn"), menu = q("rangeMenu"), lab = q("range-label"); if (!btn || !menu) return;
    if (lab && RANGE.label) lab.textContent = RANGE.label;
    function sync() { menu.querySelectorAll(".rm[data-preset]").forEach(function (x) { x.classList.toggle("on", x.getAttribute("data-preset") === RANGE.preset); }); }
    sync();
    btn.addEventListener("click", function (e) { if (menu.contains(e.target) && e.target !== btn) return; e.stopPropagation(); var open = menu.style.display !== "none"; menu.style.display = open ? "none" : "block"; if (!open) { var cf = menu.querySelector('[data-rp="from"]'), ct = menu.querySelector('[data-rp="to"]'); if (cf) cf.value = RANGE.from; if (ct) ct.value = RANGE.to; sync(); } });
    document.addEventListener("click", function () { menu.style.display = "none"; });
    menu.addEventListener("click", function (e) { e.stopPropagation(); });
    function apply(r) { RANGE = r; if (lab) lab.textContent = RANGE.label; saveRange(); menu.style.display = "none"; load(); }
    menu.querySelectorAll(".rm[data-preset]").forEach(function (b) { b.addEventListener("click", function () { apply(preset(+b.getAttribute("data-preset"))); }); });
    var ap = menu.querySelector('[data-rp="apply"]'); if (ap) ap.addEventListener("click", function () { var f = menu.querySelector('[data-rp="from"]').value, t = menu.querySelector('[data-rp="to"]').value; if (!f || !t) return; if (f > t) { var x = f; f = t; t = x; } apply({ from: f, to: t, label: f + " \u2192 " + t, preset: null }); });
  }
  function init() { root = document.querySelector('[data-b="root"]'); if (!root) return; var rf = q("refresh"); if (rf) rf.addEventListener("click", load); initRange(); load(); }
  ready(init);
})();
